import { useQuery, useMutation, useQueryClient } from 'react-query';
import { GetOffices, GetOfficeById, AddNewOffice, UpdateOffice, DeleteOffice } from '../services/backend';
import { Notify, NotifyError } from '../utils/functions';

export function useGetOffices(floorId = 'all', filter = {}) {
    return useQuery(['offices', floorId, filter], () => GetOffices(floorId, filter), {
        refetchOnWindowFocus: false,
        staleTime: 5 * 60 * 1000, // 5 minutes
        select: (data) => {
            return data?.data?.offices || [];
        },
        onError: (error) => {
            NotifyError("Failed to fetch offices", error);
            console.error("Error fetching offices:", error);
        }
    });
}

export function useGetOfficeById(officeId) {
    return useQuery(
        ['office', officeId],
        () => GetOfficeById(officeId),
        {
            enabled: !!officeId,
            staleTime: 5 * 60 * 1000, // 5 minutes
            onError: (error) => {
                NotifyError("Failed to fetch office details", error);
                console.error("Error fetching office details:", error);
            }
        }
    );
}

export function useAddOffice() {
    const queryClient = useQueryClient();
    return useMutation(({ floorId, data }) => AddNewOffice(floorId, data), {
        onSuccess: () => {
            Notify("Office added successfully");

            queryClient.invalidateQueries('offices');
        },
        onError: (error) => {
            NotifyError("Failed to add office", error);
            console.error("Error adding office:", error);
        }
    });
}

export function useUpdateOffice() {
    const queryClient = useQueryClient();
    return useMutation(({ officeId, data }) => UpdateOffice(officeId, data), {
        onSuccess: () => {
            Notify("Office updated successfully");

            queryClient.invalidateQueries('offices');
        },
        onError: (error) => {
            NotifyError("Failed to update office", error);
            console.error("Error updating office:", error);
        }
    });
}

export function useDeleteOffice() {
    const queryClient = useQueryClient();
    return useMutation(({ officeId }) => DeleteOffice(officeId), {
        onSuccess: () => {
            Notify("Office deleted successfully");

            queryClient.invalidateQueries('offices');
        },
        onError: (error) => {
            NotifyError("Failed to delete office", error);
            console.error("Error deleting office:", error);
        }
    });
}